import React from 'react';
import { useNavigate } from 'react-router-dom';

// Верхняя панель экранов входа/регистрации: «Назад» и крупный крестик, чтобы можно было выйти и листать дальше.
export default function CloseBar({ to = '/' }) {
  const navigate = useNavigate();
  const go = () => navigate(to);
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
      <button onClick={go} aria-label="Назад" style={{ background: 'none', border: 'none', color: '#a78bfa', fontSize: 16, cursor: 'pointer', padding: '10px 4px', minHeight: 44 }}>← Назад</button>
      <button onClick={go} aria-label="Закрыть" style={{ width: 44, height: 44, borderRadius: '50%', border: '1px solid #3a3a5c', background: '#22223a', color: '#fff', fontSize: 22, lineHeight: '40px', cursor: 'pointer' }}>✕</button>
    </div>
  );
}
